import { render, staticRenderFns } from "./DescriptionRecordsForm.vue?vue&type=template&id=384e19b1&"
import script from "./DescriptionRecordsForm.vue?vue&type=script&lang=js&"
export * from "./DescriptionRecordsForm.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionRecordsForm.vue?vue&type=style&index=0&id=384e19b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports